import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { CommentService } from './comment.service';
import { BaseService } from '../../shared-service/base.service';
import { WindowRef } from '../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.css']
})
export class CommentComponent implements OnInit {
  @Input() Comments: Object[] | any;
  @Input() IsCommentAllowed: boolean | any;
  CommentList: Array<any> = [];
  ShowButton: boolean = true;
  ShowMore: boolean = false;
  paramsComments: object | any = {};
  TempCmt: Object = {};
  NumberOfMoreComment: number = 0;
  ParenThreadId: number = 0;
  ConversationId: number = 0;
  UserId: number = 0;
  Type: string = "";
  JobRoleName: string = "";
  UserName: string = "";
  ValidationMsg: boolean = false;
  UserImagePath: string = "";
  ConversationType: string = "";
  @Output() count: EventEmitter<string> = new EventEmitter<string>();
  NumberOfComments: number | any;
  constructor(private commentService: CommentService,public bs: BaseService,private winRef:WindowRef) {
    this.paramsComments = { 'ConversationId': 0, 'ParentThreadId': 0, 'ThreadId': 0, 'UserId': 0, 'CommentText': '', 'Flag': '', 'recordsCount': 0, 'pageNumber': 1, 'Type': '', 'Commentcount': 0 };
    this.TempCmt = { 'CommentList': null, 'CommentText': "", 'ConversationId': 0, 'Flag': null, 'IsEditable': true, 'JobRole': '', 'NumberOfMoreComment': 0, 'PageNumber': 0, 'ParentThreadId': 0, 'RecordsCount': 0, 'ThreadId': 0, 'TotalRecords': 0, 'Type': '', 'UserId': 0, 'UserName': '', 'UserImagePath': '' };
  }
  ngOnInit() {
    /*
    getting latest comment of logged in user and in case user 
    has not commented passing a blank object with topic id and 
    other fields which will be helpful for further maniuplation of data 
    */
    this.CommentList = this.Comments;
    this.NumberOfMoreComment = this.Comments[0]["NumberOfMoreComment"];
    this.ParenThreadId = this.Comments[0]["ParentThreadId"];
    this.ConversationId = this.Comments[0]["ConversationId"];
    this.UserId = this.Comments[0]["UserId"];
    this.Type = this.Comments[0]["Type"];
    this.JobRoleName = this.Comments[0]["JobRole"];
    this.UserName = this.Comments[0]["UserName"];
    this.UserId = this.Comments[0]["UserId"];
    this.UserImagePath = this.Comments[0]["UserImagePath"];
    this.NumberOfComments = this.Comments[0]["NumberOfComment"];
    if (this.NumberOfComments > 0 && this.CommentList[0]["CommentText"] == "") {
      this.ShowButton = true;
    }
    else if (this.NumberOfComments > 1) {
      this.ShowButton = true;
    }
    else {
      this.ShowButton = false;
    }
  }
  //loading 5 comments when user click on show more comment link
  showMoreComments(ParentThreaId: number, ConversationId: number, UserId: number, Type: string): void {

    this.paramsComments['recordsCount'] = 5;
    this.paramsComments['ParentThreadId'] = ParentThreaId;
    this.paramsComments['ConversationId'] = ConversationId;
    this.paramsComments['UserId'] = UserId;
    this.paramsComments['Type'] = Type;
    if (this.ShowMore == true) {
      this.paramsComments['pageNumber'] += 1;
    }
    this.paramsComments['pageNumber'] = this.CommentList.length;
    this.commentService.getMoreComments(this.paramsComments, "****").then((data:any) => {
      if (data["CommentList"] != null) {
        this.Comments = this.Comments.concat(data["CommentList"]);
        this.CommentList = this.Comments;
        this.ConversationType = this.CommentList[1]['ConversationType'].trim();
        if (this.CommentList[0]["CommentText"] == "") {
          if (((this.CommentList.length) - 1) == data["TotalRecords"]) {
            this.ShowButton = false;
          }
        }
        else {
          if (this.CommentList.length == data["TotalRecords"]) {
            this.ShowButton = false;
          }
        }
      }
      else {
        this.ShowButton = false;
      }
      this.ShowMore = true;
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
    $('#morecomment').focus();
  }
  //saving and validating comment edit by user and pushing the updated value in object on a particular index 
  EditComment(ThreadId: string, Type: string, Index: number): boolean {
    if ($('#Text' + ThreadId).val().trim() == "") {
      this.winRef.nativeWindow.document.getElementById("CmtValdiation" + ThreadId).style.display = '';
      $("#Text" + ThreadId).addClass("reuiredtext");
      Text
      return false;
    }
    else {
      this.winRef.nativeWindow.document.getElementById("CmtValdiation" + ThreadId).style.display = 'none';
      $("#Text" + ThreadId).removeClass("reuiredtext");
    }
    this.paramsComments['ThreadId'] = ThreadId;
    this.paramsComments['Type'] = Type;
    this.paramsComments['CommentText'] = $('#Text' + ThreadId).val();
    this.paramsComments['Flag'] = 'U';
    this.paramsComments['ConversationId'] = this.ConversationId;
    this.commentService.EditComment(this.paramsComments, "****").then((data) => {
      this.winRef.nativeWindow.document.getElementById("Comment" + ThreadId).style.display = '';
      this.TempCmt = { 'CommentList': null, 'CommentText': $('#Text' + ThreadId).val(), 'ConversationId': this.CommentList[Index]["ConversationId"], 'Flag': this.CommentList[Index]["Flag"], 'IsEditable': this.CommentList[Index]["IsEditable"], 'JobRole': this.CommentList[Index]["JobRole"], 'NumberOfMoreComment': this.CommentList[Index]["NumberOfMoreComment"], 'PageNumber': this.CommentList[Index]["PageNumber"], 'ParentThreadId': this.CommentList[Index]["ParentThreadId"], 'RecordsCount': this.CommentList[Index]["RecordsCount"], 'ThreadId': this.CommentList[Index]["ThreadId"], 'TotalRecords': this.CommentList[Index]["TotalRecords"], 'Type': this.CommentList[Index]["Type"], 'UserId': this.CommentList[Index]["UserId"], 'UserName': this.CommentList[Index]["UserName"], 'UserImagePath': this.CommentList[Index]["UserImagePath"] };
      this.CommentList[Index] = this.TempCmt;
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
    return false;
  }
  //saving and validating comment fields 
  AddComment(ParentThreadId: number, ConversationId: number, UserId: number, Type: string) {
    if ($('#txtAdd' + ParentThreadId).val().trim() == "") {
      $('#txtAdd' + ParentThreadId).addClass("reuiredtext");
      this.ValidationMsg = true;
      return false;
    }
    else { this.ValidationMsg = false; $('#txtAdd' + ParentThreadId).removeClass("reuiredtext"); }
    this.paramsComments['ParentThreadId'] = ParentThreadId;
    this.paramsComments['ConversationId'] = ConversationId;
    this.paramsComments['UserId'] = UserId;
    this.paramsComments['Type'] = Type;
    this.paramsComments['CommentText'] = $('#txtAdd' + ParentThreadId).val();
    this.paramsComments['Flag'] = 'I';
    this.commentService.AddComment(this.paramsComments, "****").then((data) => {
      this.paramsComments['ParentThreadId'] = ParentThreadId;
      this.paramsComments['ConversationId'] = ConversationId;
      this.paramsComments['Type'] = Type;
      //get latest comments from db and pushing it in object
      this.commentService.GetFirstComment(this.paramsComments, "****").then((data) => {
        if (this.CommentList != undefined) {
          if (this.CommentList.length == 1) {
            this.CommentList.splice(0, 1);
            this.CommentList.push(data);
            this.NumberOfComments = this.NumberOfComments + 1;
            if (this.NumberOfComments > 1) {
              this.ShowButton = true;
            }
          }
          else {
            this.CommentList.unshift(data)
          }
        }
        this.count.emit(this.ParenThreadId + "~A");
      }, (data) => {
        this.bs.log('error','Error in getting list');
      });
      $('#txtAdd' + ParentThreadId).val("");
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
    return false;
  }
  //to display text box when user edit his / her comments
  EditElements(ThreadId: string): boolean {
    this.winRef.nativeWindow.document.getElementById('Text' + ThreadId).innerHTML = this.winRef.nativeWindow.document.getElementById("CommentText" + ThreadId).innerHTML.trim();
    this.winRef.nativeWindow.document.getElementById("Comment" + ThreadId).style.display = 'none';
    this.winRef.nativeWindow.document.getElementById("Thread" + ThreadId).style.display = '';
    this.winRef.nativeWindow.document.getElementById('Text' + ThreadId).focus();
    return false;
  }
  //deleting comments removing it from object and checking for the latest comment of logged in user
  DeleteComment(ThreadId: string, Index: number, ParentThreadId: number, ConversationId: number, UserId: number, Type: string): boolean {
    if (confirm(this.bs.getResource("rbkey_CnvrstnCmmntDltMSG")) == false) {
      return false;
    }
    this.paramsComments['ThreadId'] = ThreadId;
    this.paramsComments['Flag'] = 'D';
    this.commentService.DeleteComment(this.paramsComments, "****").then((data:any) => {
      this.count.emit(this.ParenThreadId + "~D");
      this.CommentList.splice(Index, 1);
      if (this.CommentList.length == 0) {
        this.paramsComments['ParentThreadId'] = ParentThreadId;
        this.paramsComments['ConversationId'] = ConversationId;
        this.paramsComments['UserId'] = UserId;
        this.paramsComments['Type'] = Type;
        this.commentService.GetFirstComment(this.paramsComments, "****").then((data:any) => {
          if (data["CommentText"] != null) {
            this.CommentList.push(data);
            this.Comments = this.CommentList;
          }
        }, (data) => {
          this.bs.log('error','Error in getting list');
        });
      }
      else {
        this.Comments = this.CommentList;
      }
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
    return false;
  }

  enableRebuseComment(item: Object[]|any) {
    if (item['userId'] != this.bs.getUserAttr('UserId') && !item['IsEditable']) {
      return true;
    }
    else {
      return false;
    }
  }

  enableRebuseFlag(item: Object[]|any) {
    if (item['UserId'] != this.bs.getUserAttr('UserId') && item['IsReportedRebuse']) {
      return true;
    }
    else {
      return false;
    }
  }


  postRebuseComment(item: Object[]|any) {
    let item_type
    if (this.ConversationType == "P") {
      item_type = "D";
    }
    else {
      item_type = this.ConversationType;
    }
    if (item['IsReportedRebuse']) {
      alert(this.bs.getResource('rbkey_RprtAbsMSG'));
      return false;
    }

    else {
      var message = prompt(this.bs.getResource('rbkey_RprtAbsPrmptMSG'));

      if (message != null) {
        var msgLenght = message.length;
        if (msgLenght == 0) {
          alert(this.bs.getResource('rbkey_RprtAbsVldtMSG'));
          return false;
        }
        if (msgLenght > 250) {
          alert(this.bs.getResource('rbkey_RprtAbsLnthMSG'));
          return false;
        }
        else {
          this.commentService.AddRebuseReportComment({ ItemId: this.ConversationId, ThreadId: item['ThreadId'], ItemType: item_type, UserID: this.bs.getUserAttr('UserId'), PostedContentUserId: item['UserId'], reportAbuseComment: message }, "****").then((data) => {
            this.ShowMore = false;
            this.CommentList.length = 1;
            this.showMoreComments(this.ParenThreadId, this.ConversationId, this.bs.getUserAttr('UserId'), this.Type)
          },
            (data) => {
            });
        }
      }
    }

  }
}



